/**
 * Versão do SDK, injetada no build a partir do `version` do `package.json`.
 *
 * Serve para três coisas concretas:
 *  - o suporte poder perguntar "qual versão está no ar nesse site?" e obter resposta por
 *    `window.MerlinWebchat.version`;
 *  - os eventos de analytics carregarem a versão, o que torna visível quando um problema começou;
 *  - o painel poder oferecer o snippet fixado numa versão imutável.
 */

declare const __MERLIN_SDK_VERSION__: string | undefined;

/** O fallback cobre execução direta do fonte (testes), onde o `define` do bundler não roda. */
export const SDK_VERSION: string =
  typeof __MERLIN_SDK_VERSION__ === 'string' ? __MERLIN_SDK_VERSION__ : 'dev';
